import React from 'react'
import { ModalBody } from 'reactstrap'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { ConfirmFooter } from '@/dialogs/common/confirmFooter'
import ErrorBoundary from '@/components/ErrorBoundary'
import { ValidationBoundary, ValidationState } from '@/components/validation'
import OutputReportGroupDefinitionFormContent from '@/internal-app/pages/outputReportGroupDefinitions/formContent'

class AddNewOutputReportGroupDefinitionDialog extends React.Component {
  constructor (props, context) {
    super(props, context)

    this.state = {
      id: 0,
      name: '',
      latinName: '',
      templates: []
    }
  }
  saveChanges = () => {
    this.props.onAction({ ...this.state })
  }
  onChange = (delta) => this.setState(delta)
  render () {
    return (
      <ValidationBoundary>
        <BasicHeader title='Reporting.OutputReportGroupDefinitionsTitle' {...this.props} />
        <ModalBody>
          <ErrorBoundary>
            <OutputReportGroupDefinitionFormContent
              {...this.state}
              onChange={this.onChange} />
          </ErrorBoundary>
        </ModalBody>
        <ValidationState render={({ isValid }) =>
          <ConfirmFooter primaryButtonText='Common.SaveAndClose' icon='save' {...this.props} onAction={this.saveChanges} disabled={!isValid} />
        } />
      </ValidationBoundary>
    )
  }
}

export default {
  component: AddNewOutputReportGroupDefinitionDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/addNewOutputReportGroupDefinition.js